import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Range input standing in for the calendar body's scrollbar, the vertical counterpart of
 * base-planning-board-calendar-interval-scroll. Values are scroll offsets in pixels rather than
 * day indexes, so the slider stays honest whatever row height the breakpoint applies.
 */
@Component({
  selector: 'base-customer-similar-inquiries-md-calendar-scroll',
  templateUrl: './base-customer-similar-inquiries-md-calendar-scroll.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseCustomerSimilarInquiriesMdCalendarScrollComponent {
  /** Scrollable distance, i.e. scrollHeight - clientHeight. Zero while everything fits. */
  @Input() max = 0;
  @Input() value = 0;

  @Output() valueChange = new EventEmitter<number>();

  onInputChange(event: Event): void {
    this.valueChange.emit(parseInt((event.target as HTMLInputElement).value, 10));
  }
}
